<!-- layout sem sidebar, fullscreen -->
<main class="flex justify-center items-center min-h-screen bg-gray-100 px-4">
  <router-outlet></router-outlet>
</main>
